import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subject, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Service } from 'src/app/global/services/service-state/service-state.model';
import { CreateServiceAction, CreateServiceErrorAction, CreateServiceSuccessAction } from 'src/app/global/store/global.actions';
import { State } from 'src/app/store';

@Component({
    selector: 'app-service-state-configuration',
    templateUrl: './service-state-configuration.component.html',
    styleUrls: ['./service-state-configuration.component.scss'],
})
export class ServiceStateConfigurationComponent implements OnDestroy {
    destroy$ = new Subject();

    loading = false;

    constructor(
        private router: Router,
        private store: Store<State>,
        private actions$: Actions,
    ) {}

    handleSubmit(payload: Service): void {
        this.loading = true;
        this.store.dispatch(CreateServiceAction({ service: payload }));

        this.actions$
            .pipe(
                ofType(CreateServiceSuccessAction, CreateServiceErrorAction),
                tap(() => (this.loading = false)),
                ofType(CreateServiceSuccessAction),
                tap(() => this.router.navigate(['services'])),
            )
            .subscribe();
    }

    public goBack(): void {
        this.router.navigate(['services']);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
